import { render, staticRenderFns } from "./afterClass.vue?vue&type=template&id=1049c664&scoped=true"
import script from "./afterClass.vue?vue&type=script&lang=js"
export * from "./afterClass.vue?vue&type=script&lang=js"
import style0 from "./afterClass.vue?vue&type=style&index=0&id=1049c664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1049c664",
  null
  
)

export default component.exports